import { render } from "./Microsoft365Header.vue?vue&type=template&id=751f244e"
import script from "./Microsoft365Header.vue?vue&type=script&lang=js"
export * from "./Microsoft365Header.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__